import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DetailIcon from '@mui/icons-material/Details';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';

function UserIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const { isAuthenticated, companyId, branchId, userId, logout, token, permissions } = useAuth();

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId]);

  useEffect(() => {
    fetchtableData();
  }, []);

  const fetchtableData = async () => {
    fetchData('UserApi', `/${companyId}/${companyId}`, token)//, token
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching User Details:', error);
      });
  };

  const handleDelete = async () => {
    deleteData('UserApi', `${deleteItemId}`, token)//, token
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
        setDeleteItemId(null); // Reset the item ID
        setConfirmDialogOpen(false); // Close the dialog
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });

  };

  const handleActivate = (itemId) => {
    activateData('UserApi', `${itemId}`, token)//, token
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
      })
      .catch((error) => {
        // Handle errors for the activation request
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto">
      <div className='w-full mb-2 flex'>
        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>User</h6>

        {/* {hasCreateAdministrationPermission && ( */}
        <Button
          variant="contained"
          component={Link}
          to="/userCreate"
          className="linkcolor"
          style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '5px 10px',
            border: '1px solid blue',
            textTransform: 'none',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
            maxHeight: '30px',
            marginLeft: '15px',
            textTransform: 'uppercase',
            color: 'blue',

          }}
        >
          CREATE NEW
        </Button>
        {/* )} */}

      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#58A5B3' }}>
              <TableRow>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Sl.No
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>First Name
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Last Name
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  User Name
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Contact Number
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Email
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>

                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: 'white' }}>
              {data.map((item, index) => (
                <TableRow key={item.Id} className={item.IsActive ? '' : 'inactiveRow'}
                  sx={{
                    '&:hover': { backgroundColor: '#F1E7E7' },
                    transition: 'background-color 0.3s ease-in-out'
                  }}
                >
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{index + 1}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.FirstName}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.LastName}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.UserName}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.ContactNumber}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{item.Email}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px', textAlign: 'right' }}>

                    <Link to={`/userDetail/${item.Id}`}>
                      <IconButton>
                        <DetailIcon style={{ color: 'darksalmon', fontSize: '19px' }} />
                      </IconButton>
                    </Link>

                    {/* {hasEditAdministrationPermission && ( */}
                    <Link to={`/userEdit/${item.Id}`}>
                      <IconButton color="primary">
                        <EditIcon style={{ fontSize: '19px' }} />
                      </IconButton>
                    </Link>
                    {/* )} */}

                    {/* {hasDeleteAdministrationPermission && ( */}
                    <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
                      {item.IsActive ? <DeleteIcon style={{ fontSize: '19px' }} /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                    </IconButton>
                    {/* )} */}

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>



            </Dialog>

          </Table>
        </TableContainer>
      </div>
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>

  );
}

export default UserIndex;

